<template>
  <div class="container p-0">
    <Navigation />
    <bread-crumbs />
    <section>
      <div class="content">
        <router-view :hasChildren="hasChildren"/>
      </div>
    </section>
    <vue3-progress />
    <Footer />
  </div>
  <vue-scroll-up
    tag="a"
    custom-class="btn btn-secondary btn-floating btn-lg container max-width-30"
    id="btn-back-to-top"
    :scroll-duration="100"
    :scroll-y="250"
    :always-show="false"
  ><i class="fas fa-arrow-up"></i></vue-scroll-up>
</template>

<script>
  import Footer from "@/components/FooterView.vue";
  import Navigation from "@/components/NavigationView.vue";
  import BreadCrumbs from "@/components/BreadCrumbs.vue";
  import VueScrollUp from 'vue-scroll-up';

  import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement, PointElement, LineElement } from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels';
  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement, PointElement, LineElement, ChartDataLabels)

  export default {
    name: "App",
    components: {
      Footer,
      Navigation,
      BreadCrumbs,
      VueScrollUp
    },
    created() {
      this.$progress.start();
      this.$router.beforeEach((to, from, next) => {
        this.$progress.start();
        next();
      });
      this.$router.afterEach(() => {
        this.$progress.finish();
      });
    },
    computed: {
      hasChildren() {
        if(this.$route.matched.length > 1){
          return true;
        } else {
          return false;
        }
      }
    }
  };
</script>

<style>
  @import 'https://fonts.cdnfonts.com/css/gotham';
  @import 'https://fonts.cdnfonts.com/css/montserrat';
  #videoHome {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  #myVideoHome {
    width: 100%;
    height: 100%;
  }
</style>
